import { hot } from 'react-hot-loader/root';
import React from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { LightTheme, BaseProvider } from 'baseui';

import { store, persistor } from './redux/store';
import Routes from './routes';
// import theme from './theme';

const engine = new Styletron();

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider theme={theme}>
        <StyletronProvider value={engine}>
          <BaseProvider theme={LightTheme}>
            <Router>
              <Routes />
            </Router>
          </BaseProvider>
        </StyletronProvider>
      </ChakraProvider>
    </PersistGate>
  </Provider>
);

export default hot(App);
